export const PARTICIPANT_METADATA_FILTER_KEY = 'participant_metadata';

const METADATA_SEARCH_SESSION_KEY = 'conversations_metadata_search';

const CONVERSATION_ROUTE_PREFIX = '/conversation/';

export const isConversationRoute = (pathname: string): boolean =>
  pathname.startsWith(CONVERSATION_ROUTE_PREFIX);

export const stripParticipantMetadataFilter = (
  filters: Record<string, any> | null | undefined
): Record<string, any> => {
  if (!filters) return {};
  const { [PARTICIPANT_METADATA_FILTER_KEY]: _omit, ...rest } = filters;
  return rest;
};

export const getMetadataSearchSession = (): string =>
  sessionStorage.getItem(METADATA_SEARCH_SESSION_KEY) ?? '';

export const setMetadataSearchSession = (value: string): void => {
  sessionStorage.setItem(METADATA_SEARCH_SESSION_KEY, value);
};

export const clearMetadataSearchSession = (): void => {
  sessionStorage.removeItem(METADATA_SEARCH_SESSION_KEY);
};
